/* eslint-disable @typescript-eslint/no-explicit-any */
import { flattenObject } from 'utils/format/object'
import { EventSenderPlugin } from '.'
import { EventMetadata } from '../types'

declare global {
  interface Window {
    clarity: (action: string, key: string, value: any) => void
  }
}

export class ClarityPlugin extends EventSenderPlugin {
  constructor() {
    super('Clarity')
  }

  updateMetadata(metadata: EventMetadata): void {
    if (window.clarity) {
      const metadataPlain = flattenObject(metadata)

      Object.entries(metadataPlain).forEach(([key, value]) => {
        window.clarity('set', key, value)
      })
    }
  }
}
